import React, { useState } from "react";

function ReportIt() {
  // State for handling the inputs
  const [reportTo1, setReportTo1] = useState(""); // First "Fill in as appropriate"
  const [reportTo2, setReportTo2] = useState(""); // Second "Fill in as appropriate"

  const handlePrint = (event) => {
    event.preventDefault();
    window.print();
  };

  return (
    <>
      {/* Report It Content */}
      <div id="ReportIt" className="p-6 bg-white">
        <h2 className="text-3xl font-bold mb-4 text-center">🚨 Report It 🚨</h2>

        {/* Report Statement */}
        <p className="text-lg mb-4">
          Nil defects go in{" "}
          <input
            type="text"
            className="border border-gray-300 rounded-lg px-2 py-1"
            value={reportTo1}
            onChange={(e) => setReportTo1(e.target.value)}
            placeholder="[Fill in area]"
          />
        </p>

        <p className="text-lg mb-4">
          Any defects found on your walk around must be reported to{" "}
          <input
            type="text"
            className="border border-gray-300 rounded-lg px-2 py-1"
            value={reportTo2}
            onChange={(e) => setReportTo2(e.target.value)}
            placeholder="[fill in as appropriate]"
          />{" "}
          and the slip left in the office IMMEDIATELY!
        </p>

        <p className="text-lg mb-4">
          Any defects found during your shift must be logged on a new slip and reported as soon as possible to{" "}
          <input
            type="text"
            className="border border-gray-300 rounded-lg px-2 py-1"
            value={reportTo2}
            onChange={(e) => setReportTo2(e.target.value)}
            placeholder="[fill in as appropriate]"
          />{" "}
          and the slip left in the office.
        </p>

        {/* Print Button */}
        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={handlePrint}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
          >
            Print Report
          </button>
        </div>
      </div>

      {/* CSS for print functionality */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }

            #ReportIt, #ReportIt * {
              visibility: visible;
            }

            #ReportIt {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 10mm;
              box-shadow: none;
              border: none;
              font-size: 12pt;
            }

            @page {
              size: A4 portrait;
              margin: 20mm;
            }

            .print-button {
              display: none;
            }
          }
        `}
      </style>
    </>
  );
}

export default ReportIt;